import React from "react";

const DDOption = function DDOption(props) {
    return (
        <option value={props.value}>{props.label}</option>
    );
};

export default DDOption;
